import { Injectable } from '@angular/core';
import { ObservationFormFactory } from './observation-form.factory';

@Injectable()
export class CreateObservationFormFactory extends ObservationFormFactory {

    protected getFormName(): string {
        return 'create-observation';
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/services/create-observation-form.factory.ts